/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2026-03-25 21:12:17
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-28 14:56:32
 * @Description: file content
 */
/**
 * PH (菲律宾) 常量覆写
 * 命名规则同 diffconfig/config/constants.ts：Module-Page-Constant
 */
export default {
  'Common-Api-CountryCode': 'PH',
  'Common-Currency-Symbol': 'PHP',

  // ─── Store 站点设置 / Print 打印模块 ──────────────────
  /** 打印面单默认尺寸描述 */
  'Store-PrintLabel-Size': '100*90' as string,
  /** 打印面单第二尺寸描述 */
  'Store-PrintLabel-Size2': '100*180' as string,
  // 全局品牌标识 区别home与yoyi 默认yoyi
  'Common-Brand-Name': 'Home' as string,

  // ─── LearningCenter 学习中心模块 ──────────────────────────
  /** 学习中心 - 沙滩说PC地址（根据环境不同） */
  'LearningCenter-Sandstalk-Url': import.meta.env.VITE_APP_SANDSTALK_URL || '' as string,
  /** 学习中心 - 开发者账号标识 */
  'LearningCenter-Provider': 'ph_post_station' as string,
  /** 学习中心 - 身份标识前缀 */
  'LearningCenter-IdentifierPrefix': 'PHYY' as string,
  /** 学习中心 - 图标路径（菲律宾使用红色图标） */
  'LearningCenter-Icon-Path': 'ph' as string,
}
